import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { selectMobileBanners } from 'models/virtual_event';
import { useSelector } from 'react-redux';
import FloatingFooter from 'components/footer_v2/FloatingFooter';
import useMobileLobbyViewItems from './useMobileLobbyViewItems';
import BannerCarousel from './v2/BannerCarousel';

const RootContainer = styled.div`
  width: 100%;
  height: inherit;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  margin: auto;
`;

const StyledLinkContainer = styled.div`
  flex: 0 0 auto;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin: 24px 16px;
  padding-bottom: 49.56%;
  background: ${({ background }) => background};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const StyledLink = styled(Link)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  overflow: hidden;
`;

const StyledAnchor = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  overflow: hidden;
`;

const StyledText = styled.div`
  flex: 0 0 auto;
  font-weight: 900;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: -0.408px;
  color: #FFF;
`;

const SliderContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 16px 16px 0;
`;

const MobileLobbyLink = ({
  redirectExternal,
  redirectUrl,
  backgroundImageUrl,
  text,
  showText,
}) => {
  const {
    themeColor,
  } = useSelector((s) => s.eventConfigs);
  return (
    <StyledLinkContainer background={backgroundImageUrl ? `url('${backgroundImageUrl}')` : themeColor}>
      {redirectExternal
        ? <StyledAnchor href={redirectUrl} target="_blank" rel="noopener noreferrer"><StyledText>{showText ? text : ''}</StyledText></StyledAnchor>
        : <StyledLink to={redirectUrl}><StyledText>{showText ? text : ''}</StyledText></StyledLink>}
    </StyledLinkContainer>
  );
};

MobileLobbyLink.propTypes = {
  redirectExternal: PropTypes.bool.isRequired,
  redirectUrl: PropTypes.string.isRequired,
  backgroundImageUrl: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  showText: PropTypes.bool.isRequired,
};

const MobileLobbyLinkMemo = React.memo(MobileLobbyLink);

const MobileLobbyViewLinks = () => {
  const mobileLobbyLinkList = useMobileLobbyViewItems();
  return (
    <>
      {mobileLobbyLinkList.map((mobileLobbySetting) => {
        const { redirectUrl, backgroundImageUrl, text } = mobileLobbySetting;
        return (
          <MobileLobbyLinkMemo
            {...mobileLobbySetting}
            key={`${redirectUrl}-${backgroundImageUrl}-${text}`}
          />
        );
      })}
    </>
  );
};

const GenericMobileLobbyView = () => {
  const banners = useSelector(selectMobileBanners);

  return (
    <RootContainer>
      <SliderContainer>
        <BannerCarousel banners={banners} maxSliderHeight={400} bullet />
      </SliderContainer>
      <MobileLobbyViewLinks />
      <FloatingFooter />
    </RootContainer>
  );
};

export default React.memo(GenericMobileLobbyView);
